import { all, takeLatest, put, call } from 'redux-saga/effects';

import i18n from '@dragonfruit/i18n';

import {
  FETCH_PLAN_DATA,
  fetchPlanDataFailure,
  fetchPlanDataSuccess,
} from '@dragonfruit/redux/plans';
import { sendGtmEvent } from '@dragonfruit/redux/googleTagManager';
import { showAlertBanner } from '@dragonfruit/redux/alertBanner';
import { fetchConsentData } from '@dragonfruit/redux/annualConsent';

import transformCheckoutCollectionList, {
  getFirstSelectedCollection,
  transformBundleContent,
  transformBundleCourse,
  transformBundleLiveTopic,
  transformBundleGroupPass,
} from '@dragonfruit/sagas/purchase/transformCheckoutCollection';

import { VIEW_CONTENT, PRODUCT_DETAIL } from '@dragonfruit/constants/gtmEvents';
import { ALERT_ERROR_THEME } from '@dragonfruit/constants/alertBannerThemes';
import {
  BUNDLE,
  CONTENT_OFFERING_TYPE_LIST,
} from '@dragonfruit/constants/checkoutCollectionTypes';

import { apiFetchAddon } from '@dragonfruit/services/apis';

export function* sendPurchasePageViewEvent({
  name,
  planType,
  id,
  currency,
  paymentMethods,
}) {
  const { sku = '', price } = paymentMethods.find(
    ({ isSelected }) => isSelected
  );

  yield put(
    sendGtmEvent({
      eventName: PRODUCT_DETAIL,
      data: {
        ecommerce: {
          detail: {
            products: [
              {
                id: sku,
                name,
                price,
                category: planType,
                quantity: 1,
                position: 1,
              },
            ],
          },
        },
      },
    })
  );

  yield put(
    sendGtmEvent({
      eventName: VIEW_CONTENT,
      data: {
        content_ids: [id],
        content_name: name,
        contents: sku,
        content_type: planType,
        currency,
        value: price,
      },
    })
  );
}

export function* fetchPlanDataFlow(action) {
  const { id, type, bundleContents } = action.payload;

  const transformedBundleContents = transformBundleContent(bundleContents);
  const isContentOffering = CONTENT_OFFERING_TYPE_LIST.includes(type);

  try {
    const idKeyName = isContentOffering
      ? 'checkout_collection_id'
      : 'payment_method_id';
    const {
      infos,
      infosHeader,
      checkoutCollections = [],
      courses = [],
      liveTopics = [],
      groupPasses = [],
    } = yield call(apiFetchAddon, {
      [idKeyName]: id,
      bundle_contents: transformedBundleContents,
    });

    const collectionList = transformCheckoutCollectionList(checkoutCollections);

    const selectedCollectionPlan = getFirstSelectedCollection(collectionList)
      .plan;

    yield call(sendPurchasePageViewEvent, selectedCollectionPlan);

    const { isContract, id: planId } = selectedCollectionPlan;
    if (isContract) {
      yield put(fetchConsentData({ planId }));
    }

    const contentList = [
      ...courses.map(transformBundleCourse),
      ...liveTopics.map(transformBundleLiveTopic),
      ...groupPasses.map(transformBundleGroupPass),
    ];

    yield put(
      fetchPlanDataSuccess({
        collectionList,
        infos,
        infosHeader,
        contentList,
        bundleContents: transformedBundleContents,
      })
    );
  } catch (err) {
    yield put(fetchPlanDataFailure(err.message));
    yield i18n.loadNamespaces(['purchase', 'premium']);
    yield put(
      showAlertBanner({
        message:
          type === BUNDLE
            ? 'purchase:purchase.content.errorMessage.collectionNotFound'
            : 'premium:premium.packageInvildate',
        theme: ALERT_ERROR_THEME,
      })
    );
  }
}

export default function*() {
  yield all([takeLatest(FETCH_PLAN_DATA, fetchPlanDataFlow)]);
}



// WEBPACK FOOTER //
// ./app/sagas/plans.js